import { IFacility } from "../types/IFacility";


export const address = (facility: IFacility) => `${facility?.street} ${facility?.city}, ${facility?.state} ${facility?.postal}`;

export const addressEl = (facility: IFacility) => <div>
    <b>{facility?.street}</b>&nbsp;<br />{facility?.city}, {facility?.state} {facility?.postal}
</div>;
